/** Route table. Single source for the nav, the footer, the router and the sitemap. */

export interface RouteDef {
  /** Path as served. No trailing slash except the root. */
  path: string;
  /** Label in the primary nav. Omitted routes still render, just not in the nav. */
  navLabel?: string;
  /** Included in sitemap.xml. */
  sitemap: boolean;
  priority: number;
}

export const ROUTES: RouteDef[] = [
  { path: "/", sitemap: true, priority: 1.0 },
  { path: "/what-we-do", navLabel: "What we do", sitemap: true, priority: 0.9 },
  { path: "/consulting", navLabel: "Consulting", sitemap: true, priority: 0.9 },
  {
    path: "/software-development",
    navLabel: "Software Development",
    sitemap: true,
    priority: 0.9,
  },
  { path: "/products", navLabel: "Products", sitemap: true, priority: 0.9 },
  { path: "/labista", sitemap: true, priority: 0.8 },
  { path: "/work", navLabel: "Work", sitemap: true, priority: 0.8 },
  { path: "/about", navLabel: "About", sitemap: true, priority: 0.7 },
  { path: "/contact", sitemap: true, priority: 0.8 },
];

export const NAV_LINKS = ROUTES.filter((r) => r.navLabel).map((r) => ({
  href: r.path,
  label: r.navLabel!,
}));

/**
 * Pages that are NOT part of the React app and must therefore never be
 * routed client-side — the anchor has to do a real navigation.
 *
 * /hazribook is a hand-written static page in public/. It has its own
 * design system and its own head; the React router must not swallow it.
 */
export const EXTERNAL_PATHS = ["/hazribook"];
